import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/cn'

export type WalletMethod = 'crypto' | 'bank'

export function MethodTabs({
  value,
  onChange,
}: {
  value: WalletMethod
  onChange: (v: WalletMethod) => void
}) {
  const { t } = useTranslation('common')

  return (
    <div
      className="grid grid-cols-2 gap-0.5 rounded-lg border border-terminal-border/40 bg-terminal-elevated/50 p-0.5"
      role="tablist"
    >
      {(['crypto', 'bank'] as const).map((method) => (
        <button
          key={method}
          type="button"
          role="tab"
          aria-selected={value === method}
          onClick={() => onChange(method)}
          className={cn(
            'h-9 rounded-md text-xs font-semibold transition-colors',
            value === method
              ? 'bg-accent text-white shadow-sm'
              : 'text-terminal-muted hover:text-terminal-fg',
          )}
        >
          {method === 'crypto' ? t('wallet.methodCrypto') : t('wallet.methodBank')}
        </button>
      ))}
    </div>
  )
}
